import type { LangProps, TPAComponentProps } from '../../types';
import type { RadioButtonTheme } from '../RadioButton/types';

export interface RadioButtonGroupProps extends TPAComponentProps, LangProps {
  label?: string | React.ReactNode;
  children?: any;
  layout?: RadioButtonGroupLayout;
  error?: boolean;
  newErrorMessage?: boolean;
  errorText?: string;
  disabled?: boolean;
  value?: string;
  name: string;
  withSpacing?: boolean;
  theme?: RadioButtonTheme;
  fluid?: boolean;
  ariaLabelledBy?: string;
  onChange(value: string): void;
}

export interface RadioButtonGroupDefaultProps {
  value: string;
  layout?: RadioButtonGroupLayout;
}

export enum RadioButtonGroupLayout {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
